import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import { fincasCellContent } from "../../../../helpers/data";
const ver_img = require("assets/img/icons/ver.png");
const recepcion_img = require("assets/img/icons/recepciones_activo.png");

export const RecibidosTable = ({
    traslados,
    setTrasladoSeleccionado,
    modo,
}) => {
    return (
        <div className="new-table-wrapper listado-traslados__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th>NÚMERO</th>
                        <th>ORIGEN</th>
                        <th>DESTINO</th>
                        <th>FECHA DE ENVÍO</th>
                        <th>FECHA DE ENTREGA</th>
                        <th>PILOTO</th>
                        <th>PESO DE SALIDA</th>
                        <th>FINCAS</th>
                    </tr>
                </thead>
                <tbody>
                    {traslados.length === 0 && (
                        <tr>
                            <td colSpan={9} className="text-center">
                                No hay traslados recibidos.
                            </td>
                        </tr>
                    )}
                    {traslados.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td>
                                    <div className="table-actions">
                                        <img
                                            src={ver_img}
                                            alt="Ver"
                                            className="action_img"
                                            title="Ver detalles"
                                            onClick={() => {
                                                setTrasladoSeleccionado(item);
                                            }}
                                        />
                                        {modo === "recepcion" && (
                                            <Link
                                                to={`traslados/${item.id}/recepcion/`}
                                                className="px-2"
                                            >
                                                <img
                                                    src={recepcion_img}
                                                    alt="Recepcionar"
                                                    className="action_img"
                                                    title="Recepcionar traslado"
                                                />
                                            </Link>
                                        )}
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.numero}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.acopio_origen
                                        ? item.acopio_origen.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.acopio_destino
                                        ? item.acopio_destino.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    {moment(item.fecha_salida).format(
                                        "DD/MM/YYYY HH:mm:ss",
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {moment(item.fecha_recepcion).format(
                                        "DD/MM/YYYY HH:mm:ss",
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.piloto ? item.piloto.nombre : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.peso_salida}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap listado-traslados__table-ellipsis-cell">
                                    {fincasCellContent(item.detalles)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
